import { ReactNode } from 'react';
import { Box, BoxProps, useTheme } from '@mui/material';
import HeaderLogo from './HeaderLogo';

const MAX_WIDTH = 720;

export interface PublicPageLayoutProps {
  children: ReactNode;
  showLogo?: boolean;
  containerProps?: Partial<BoxProps>;
}

export default function PublicPageLayout({
  children,
  showLogo = true,
  containerProps = {},
}: PublicPageLayoutProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        backgroundColor: 'background.default',
      }}
    >
      <Box component="main" sx={{ flex: 1 }}>
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            maxWidth: '1200px',
            mx: 'auto',
          }}
        >
          <Box
            sx={{
              width: '100%',
              mx: 'auto',
              maxWidth: { lg: `${MAX_WIDTH}px` },
              zIndex: 10,
            }}
          >
            {showLogo && <HeaderLogo />}

            <Box sx={{ px: 2, pb: 4 }}>
              <Box
                sx={{
                  maxWidth: `${MAX_WIDTH}px`,
                  mx: 'auto',
                  background: theme.palette.secondary.main,
                  borderRadius: 3, // 12px
                  overflow: 'visible',
                  position: 'relative',
                  backdropFilter: 'blur(16px)',
                  p: { xs: 4, md: 6 },
                  ...containerProps.sx,
                }}
                {...containerProps}
              >
                {children}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
